var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProteinTurkeyNoborder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "525px",
    height: "525px",
    viewBox: "0 0 525 525",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "protein_turkey_noborder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "protein_turkey_noborder",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-turkey-3993950",
    transform: "translate(163, 115)",
    fill: "#2A322A",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.97198,254.469946 C121.270767,248.511198 113.02556,250.484234 119.023848,239.5834 C127.514737,225.345278 116.111673,206.780571 130.005563,197.922543 C132.0718,196.605217 132.458052,166.298707 134.619295,165.123887 C150.084531,132.549713 173,93.8929887 173,52.2611909 C172.951563,38.4247702 167.456014,25.172168 157.711642,15.3902967 C147.966819,5.60785969 134.765737,0.0905629339 120.986921,0.043034175 C111.545901,-0.337127998 102.171391,1.80680378 93.8306021,6.26262493 C85.4904898,10.7184461 78.4758403,17.3181537 73.5135276,25.3895555 C92.0742906,34.3895786 96.869765,95.4808951 96.869765,104.794269 C96.869765,158.092113 77.1118243,180.839151 57.8555258,184.451337 C49.1636612,203.657767 31.7379997,272.723758 32.2426259,283.609036 C32.2804975,284.425964 32.9477414,287.497486 33.1924276,287.58191 C46.1616597,292.056691 80.3888798,273.863178 89.4576917,269.638665 L109.97198,254.469946 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.779574,183.017554 C115.329992,190.055762 107.411025,198.959258 101.508985,209.176962 C83.9293527,240.926567 26.1788887,265.795712 32.7629455,288.284684 C39.3470023,310.773656 124.360874,325.715473 167.809911,290.679748 C205.378218,260.386031 213.230265,193.585188 167.809911,183.017554 C122.389557,172.449921 135.256533,174.955187 124.779574,183.017554 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,42 C27.9834528,49.2179581 0,63.588658 0,88 C9.82051848,78.0244623 25.7606178,77.5822903 39.7815775,79.8409978 C40.1995698,76.8251297 40.4279537,73.7874108 40.4624269,70.7408394 C40.6572311,60.6856301 43.2426917,50.8243892 48,42 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4349204,170.954338 C74.628788,163.435809 84.4588965,144.79783 84.9547086,109.228634 C85.0150971,107.985793 85.0150971,106.743066 84.9547086,105.500226 C84.9547086,73.9102396 73.7608409,36 67.9513374,36 L66.2820299,36.4407029 C60.0964159,38.9659838 50.8831462,55.3958227 50.8831462,70.8117359 L50.8788329,70.8161427 C50.8788329,74.6106641 50.5294345,78.3963854 49.8306488,82.1242294 C46.3065184,102.912697 34,119.147693 34,140.249804 C34.1854823,157.561116 41.6046965,175 51.0641054,175 C55.4895602,174.933895 59.7944012,173.523619 63.4349204,170.954338 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProteinTurkeyNoborder);
export default __webpack_public_path__ + "static/media/protein_turkey_noborder.30f6193020169fadd26dde21d5e7c987.svg";
export { ForwardRef as ReactComponent };